var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "onboarding-quicktrial__signup" }, [
    _c("header", [
      _c(
        "p",
        {
          class: [
            "onboarding-quicktrial__signup-title",
            _vm.isDesktop
              ? "typographies-display-medium"
              : "typographies-display-small"
          ]
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t.__("pages.onboarding.trial.OnboardingQuicktrial.title")
              ) +
              "\n        "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("CompassButton", {
          staticClass: "onboarding-quicktrial__signup-google-button",
          attrs: {
            label: _vm.$t.__("common.actions.subscribe_with_google"),
            type: "secondary",
            size: _vm.componentSize
          },
          on: { click: _vm.signUpGoogle },
          scopedSlots: _vm._u([
            {
              key: "prefix",
              fn: function() {
                return [
                  _c("SaasIcon", {
                    attrs: {
                      icon: "svgGoogle",
                      width: _vm.iconSize,
                      height: _vm.iconSize
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _c("p", { staticClass: "onboarding-quicktrial__signup-divider" }, [
          _c(
            "span",
            {
              staticClass:
                "onboarding-quicktrial__signup-divider-text typographies-paragraph-medium-semibold"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t.__("common.labels.or")) +
                  "\n            "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "onboarding-quicktrial__signup-form",
            attrs: {
              rules: _vm.rules,
              inlineMessage: "",
              labelPosition: "top",
              model: _vm.form
            }
          },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t.__("common.labels.your_company_name"),
                  prop: "name",
                  error: _vm.errors.get("name")
                }
              },
              [
                _c("CompassInput", {
                  attrs: { size: _vm.componentSize },
                  model: {
                    value: _vm.form.name,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassFormItem",
              {
                attrs: {
                  label: _vm.$t.__("common.labels.country"),
                  size: _vm.isDesktop ? "large" : "medium",
                  tooltip:
                    "Sélectionnez le pays dans lequel votre établissement est immatriculé."
                }
              },
              [
                _c(
                  "CompassSelect",
                  {
                    attrs: {
                      filterable: true,
                      size: _vm.isDesktop ? "large" : "medium"
                    },
                    model: {
                      value: _vm.form.country,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "country", $$v)
                      },
                      expression: "form.country"
                    }
                  },
                  _vm._l(_vm.countries, function(item) {
                    return _c("CompassDropdownSelectOption", {
                      key: item.code,
                      attrs: {
                        label: item.name,
                        value: item.code,
                        flag: item.code.toLowerCase(),
                        type: "flag"
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "onboarding-quicktrial__signup-form-items-horizontal"
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "onboarding-quicktrial__signup-form-item",
                    attrs: {
                      label: _vm.$t.__("common.labels.name"),
                      prop: "lastname",
                      error: _vm.errors.get("lastname")
                    }
                  },
                  [
                    _c("CompassInput", {
                      attrs: { size: _vm.componentSize },
                      model: {
                        value: _vm.form.lastname,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "lastname", $$v)
                        },
                        expression: "form.lastname"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "onboarding-quicktrial__signup-form-item",
                    attrs: {
                      label: _vm.$t.__("common.labels.first_name"),
                      prop: "firstname",
                      error: _vm.errors.get("firstname")
                    }
                  },
                  [
                    _c("CompassInput", {
                      attrs: { size: _vm.componentSize },
                      model: {
                        value: _vm.form.firstname,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "firstname", $$v)
                        },
                        expression: "form.firstname"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t.__("common.labels.phone"),
                  prop: "phone_number",
                  error: _vm.errors.get("phone_number")
                }
              },
              [
                _c("CompassTelInput", {
                  attrs: {
                    value: _vm.form.phone_number,
                    error: !_vm.isValidPhone,
                    defaultCountry: _vm.form.phone_country.toLowerCase(),
                    size: _vm.componentSize
                  },
                  on: {
                    input: _vm.updatePhoneNumber,
                    validate: _vm.onValidateTelInput,
                    blur: _vm.onBlurTelInput,
                    "country-changed": _vm.updatePhoneCountry
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t.__("common.labels.professional_email"),
                  prop: "login",
                  error: _vm.errors.get("login")
                }
              },
              [
                _c("CompassInput", {
                  attrs: { size: _vm.componentSize, type: "email" },
                  model: {
                    value: _vm.form.login,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "login", $$v)
                    },
                    expression: "form.login"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticClass:
                  "onboarding-quicktrial__signup-form-item--password",
                attrs: {
                  label: _vm.$t.__("common.labels.password"),
                  prop: "password",
                  error: _vm.errors.get("password")
                }
              },
              [
                _c("password-with-badge-input", {
                  attrs: { size: _vm.componentSize },
                  model: {
                    value: _vm.form.password,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c("CompassCheckbox", {
                  attrs: {
                    modelValue: "mailing",
                    label: _vm.$t.__(
                      "pages.onboarding.trial.OnboardingQuicktrial.mailing_label"
                    ),
                    checked: _vm.form.mailing
                  },
                  on: {
                    change: function() {
                      _vm.form.mailing = !_vm.form.mailing
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("p", {
              staticClass:
                "onboarding-quicktrial__signup-form-terms typographies-paragraph-medium-regular",
              domProps: { innerHTML: _vm._s(_vm.termsLabelLegalInformation) }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "onboarding-quicktrial__signup-form-item",
              attrs: {
                label: _vm.$t.__("common.actions.create_account"),
                type: "primary",
                size: _vm.componentSize,
                loading: _vm.loading
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm("form", "signup")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            class: [
              "onboarding-quicktrial__signup-signin",
              _vm.isDesktop
                ? "typographies-paragraph-large-semibold"
                : "typographies-paragraph-medium-semibold"
            ]
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "pages.onboarding.trial.OnboardingQuicktrial.already_acount"
                  )
                ) +
                "\n            "
            ),
            _c(
              "a",
              {
                staticClass: "onboarding-quicktrial__signup-signin--link",
                attrs: { href: _vm.urlSipHost }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t.__("common.actions.login")) +
                    "\n            "
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("p", {
          staticClass:
            "onboarding-quicktrial__signup-terms typographies-paragraph-small-regular",
          domProps: { innerHTML: _vm._s(_vm.legalsTerms) }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }